import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import { ApolloProvider } from 'react-apollo'

import client from './configureClient'
import { URLS } from './constants'
import App from './components/App'
import Board from './components/Board'
import Dashboard from './components/Dashboard'
import UserSettings from './components/UserSettings'
import OrgSettings from './components/OrgSettings'
import SlackInstall from './components/SlackInstall'
// import InstallOrLoginOld from './components/InstallOrLoginOld'
import SlackSignIn from './components/SlackSignIn'
import Logout from './components/Logout'
import NotFound from './components/404'
import QuestionDetail from './components/QuestionDetail'
import SlackInstallDenied from './components/SlackInstallDenied'
import SlackInstallThanks from './components/SlackInstallThanks'
import SlackSignInDenied from './components/SlackSignInDenied'
import SlackSignInSuccess from './components/SlackSignInSuccess'
import { isAuthenticated, setPathBeforeAuth } from './utils'

const AuthRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      isAuthenticated() ? (
        <Component {...props} />
      ) : (
        // console.log("window.location.pathname :"+window.location.pathname),
        // localStorage.setItem("before_auth_path", window.location.pathname),
        (setPathBeforeAuth(),
        (
          <Redirect
            to={{
              pathname: URLS.LOGIN,
              state: {
                // from: props.location.pathname === URLS.LOGOUT ? URLS.DASHBOARD : props.location,
                state: { from: props.location },
              },
            }}
          />
        ))
      )
    }
  />
)

const Root = () => (
  <ApolloProvider client={client}>
    <App>
      {/* ^ original layout, changing to core.ui DefaultLayout to test */}
      {/*<DefaultLayout>*/}
      <Switch>
        {/* Root Path "/" if logged in redirect to dashboard otherwise redirect to login. */}
        <Route exact path={URLS.HOME} render={() => <Redirect to={URLS.DASHBOARD} />} />

        {/* Note: Changing the slack instalL/login URLs below requires backend changes */}

        {/* Slack App Install Routes */}
        <Route path={URLS.SLACK_INSTALL_THANKS} component={SlackInstallThanks} />
        <Route path={URLS.SLACK_INSTALL_DENIED} component={SlackInstallDenied} />
        <Route path={URLS.SLACK_INSTALL} component={SlackInstall} />
        {/*<Route path={URLS.SLACK_INSTALL} component={InstallOrLoginOld} />*/}

        {/* Slack Login Routes */}
        <Route path={URLS.SLACK_LOGIN_DENIED} component={SlackSignInDenied} />
        <Route path={URLS.SLACK_LOGIN_SUCCESS} component={SlackSignInSuccess} />
        {/*<Route path={URLS.LOGIN} component={InstallOrLogin} />*/}
        <Route path={URLS.LOGIN} component={SlackSignIn} />

        {/* Routes that require Authentication */}
        <AuthRoute path={URLS.LOGOUT} component={Logout} />
        <AuthRoute path={URLS.DASHBOARD} component={Dashboard} />
        <AuthRoute path={URLS.USER_SETTINGS} component={UserSettings} />
        <AuthRoute path={URLS.ORG_SETTINGS} component={OrgSettings} />
        <AuthRoute path={URLS.BOARD_DETAIL} component={Board} />
        <AuthRoute path={URLS.QUESTION_DETAIL} component={QuestionDetail} />

        {/* Error Routes */}
        <Route component={NotFound} />

        {/* Old Not Used Routes. Audit then delete*/}
        {/*<Route path={URLS.ORGANIZATION_DETAIL} component={Organization} />*/}
      </Switch>
    </App>
    {/*</DefaultLayout>*/}
  </ApolloProvider>
)

// export default withRouter(Root)
export default Root



// WEBPACK FOOTER //
// ./src/Root.js